import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { UtilsService } from '@common/services';
import { CustomErrorKey } from '@ui/components/form9/common/error-msg.service';

export function inputText9RequiredValidator (customMsg: string = null): ValidatorFn
{
    return (formControl: FormControl): ValidationErrors | null =>
    {
        if (UtilsService.isNullOrEmpty(formControl.value))
        {
            const validationErrors: ValidationErrors = { required: true };

            if (!UtilsService.isNullOrEmpty(customMsg))
            {
                validationErrors[CustomErrorKey] = customMsg;
            }

            return validationErrors;
        }

        return null;
    };
}
